import { useEffect, useMemo } from "react";

import { useLazyQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { getGroupName } from "../api/queries/getGroupV2";
import { type GetGroupNameQuery, type GetGroupNameQueryVariables } from "../api/queries/getGroupV2.gql-generated";
import { GroupInfoModel } from "../model";

export function useGroupInfo(groupId: string): GroupInfoModel {
    const { orgId } = useParams();
    const [getGroupData, { data }] = useLazyQuery<GetGroupNameQuery, GetGroupNameQueryVariables>(getGroupName);

    useEffect(() => {
        if (groupId && orgId) {
            getGroupData({ variables: { id: groupId, organizationId: orgId } });
        }
    }, [getGroupData, groupId, orgId]);

    return useMemo(
        () =>
            GroupInfoModel.createDefault({
                id: groupId,
                name: data?.getGroupV2?.group?.name ?? "",
            }),
        [data, groupId],
    );
}
